import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

function progressColor(pct: number): string {
  if (pct >= 100) return "bg-success";
  if (pct >= 60) return "bg-primary";
  if (pct >= 30) return "bg-[var(--sr-sitron)]";
  return "bg-foreground/30";
}

interface Props {
  loggedHours: number;
  assignedHours: number;
  showLabel?: boolean;
  className?: string;
}

/**
 * VIB-797: Per-oppgave progress bar — logget vs tildelt timer.
 * Mønstret etter ProjectProgressBar men på oppgavenivå.
 */
export function TaskProgressBar({ loggedHours, assignedHours, showLabel = false, className }: Props) {
  if (assignedHours <= 0) {
    return <span className="text-[11px] text-muted-foreground/40">—</span>;
  }

  const pct = Math.round((loggedHours / assignedHours) * 100);

  const bar = (
    <div className={cn("h-1.5 w-full bg-muted overflow-hidden", className)}>
      <div
        className={cn("h-full transition-all", progressColor(pct))}
        style={{ width: `${Math.min(pct, 100)}%` }}
      />
    </div>
  );

  const tooltipText = `${loggedHours.toFixed(1).replace(".", ",")}t av ${assignedHours.toFixed(1).replace(".", ",")}t tildelt (${pct}%)`;

  if (showLabel) {
    return (
      <div className="flex items-center gap-2">
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="flex-1">{bar}</div>
          </TooltipTrigger>
          <TooltipContent className="text-xs">{tooltipText}</TooltipContent>
        </Tooltip>
        <span className="text-[11px] tabular-nums text-muted-foreground whitespace-nowrap">{pct}%</span>
      </div>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{bar}</TooltipTrigger>
      <TooltipContent className="text-xs">{tooltipText}</TooltipContent>
    </Tooltip>
  );
}

export default TaskProgressBar;
